<era-pane>
  <h5 class="small-caps"
      i18n>WiFi Preset</h5>
  <ml-mdm-wifi-preset-install-ui [commandProgress]="commandProgress$"
                                 [configurationProfile]="configurationProfile"
                                 [wifiProfiles]="wifiPresets | async"
                                 (installProfile)="installProfile($event)"></ml-mdm-wifi-preset-install-ui>
</era-pane>